<template>
  <div class="route-view has-top dark">
    <div class="inline-flex">
      <h1 class="title">
        <span>{{ $t('statement.statementTitle') }}</span>
      </h1>
      <div class="block">
        <button class="button small is-success" @click="modalSlip">
          {{ $t('statement.uploadStatusBtn') }}
        </button>
      </div>
    </div>
    <div v-for="(statement, index) in statements" :key="index">
      <div :class="statement.statementType.toLowerCase()" class="log">
        <div class="detail">
          <div class="type m-r-10">
            <i :class="icon(statement.statementType.toLowerCase())"></i>
          </div>
          <div>
            <div
              class="activity m-t-10 m-b-10"
              v-html="
                activity(
                  statement.statementType.toLowerCase(),
                  statement.from,
                  statement.to,
                  description(statement)
                )
              "
            ></div>
            <div
              class="status"
              v-html="
                `${$t('statement.status')}: ${status(
                  statement.statementType,
                  statement.status
                )}`
              "
            ></div>
            <div class="datetime m-t-5">
              {{ statement.createdAt | datetimeFormat }}
            </div>
            <div class="timeago">
              {{ statement.createdAt | timeagoFormat }}
            </div>
          </div>
        </div>
        <div class="amount">
          {{ sign(statement.statementType.toLowerCase()) }}
          {{ statement.amount | numberFormat }}
        </div>
      </div>
      <!-- <hr /> -->
    </div>

    <b-pagination
      :total="total"
      :current.sync="current"
      :range-before="rangeBefore"
      :range-after="rangeAfter"
      :order="order"
      :size="size"
      :simple="isSimple"
      :rounded="isRounded"
      :per-page="perPage"
      :icon-prev="prevIcon"
      :icon-next="nextIcon"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    />

    <modal-slip
      v-if="modalSlipActive"
      :is-active="modalSlipActive"
      @closeModal="modalSlip"
    />
  </div>
</template>

<script>
import apiStatement from '@/api/statement'

import ModalSlip from '@/views/user/components/modals/Slip'
import i18n from '@/language'
export default {
  // 01/04/2020 17:17:17 - 3 days ago
  name: 'UserStatement',
  components: {
    ModalSlip
  },
  props: {
    page: String
  },
  data() {
    return {
      total: 0,
      current: 1,
      perPage: 10,
      rangeBefore: 3,
      rangeAfter: 1,
      order: '',
      size: '',
      isSimple: false,
      isRounded: false,
      prevIcon: 'chevron-left',
      nextIcon: 'chevron-right',
      statements: [],
      modalSlipActive: false
    }
  },
  watch: {
    current: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getStatement()
        }
      }
    }
  },
  created() {
    this.$emit('childinit', this.page)
  },
  methods: {
    async getStatement() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          const data = await apiStatement.getStatement(
            this.current,
            this.perPage
          )
          this.total = data.total
          this.statements = data.statements

          loading.hide()
        } catch {
          loading.hide()
        }
      }, 200)
    },
    icon(type) {
      switch (type) {
        case 'deposit':
          return 'fas fa-wallet'
        case 'bonus':
          return 'fas fa-gift'
        case 'finish_bonus':
          return 'fas fa-gift'
        case 'withdraw':
          return 'fas fa-hand-holding-usd'
        case 'transfer':
          return 'fas fa-exchange-alt'
        default:
          return 'fas fa-question'
      }
    },
    activity(type, from, to, bonus) {
      switch (type) {
        case 'deposit':
          return `${i18n.t('statement.depositMsg')} ${to}`
        case 'bonus':
          return `${i18n.t('statement.bonusMsg')}<br> ${
            bonus ? `${bonus.description}` : ''
          }`
        case 'finish_bonus':
          return `${i18n.t('statement.finishBonusMsg')} ${
            bonus ? `${bonus.description}` : ''
          }`
        case 'withdraw':
          return `${i18n.t('statement.withdrawMsg')} ${from}`
        case 'transfer':
          return `${i18n.t('statement.transferMsg')}<br>${from} => ${to}`
        default:
          return 'fas fa-question'
      }
    },
    sign(type) {
      switch (type) {
        case 'deposit':
        case 'bonus':
          return '+'
        case 'withdraw':
          return '-'
        default:
          return ''
      }
    },
    status(type, status) {
      let style = 'has-text-warning'
      let icon = 'fa-info-circle'
      let text = i18n.t('statement.inProgressMsg')

      if (status === 'SUCCESS') {
        style = 'has-text-success'
        icon = 'fa-check-circle'
        text = i18n.t('statement.successMsg')
      } else if (status === 'FAILED') {
        style = 'has-text-danger'
        icon = 'fa-times-circle'
        text = i18n.t('statement.failMsg')
      }

      return `<span class="${style} m-l-5"><i class="fas ${icon}"></i> ${text}</span>`
    },
    description(statement) {
      if (statement.bonus) return statement.bonus
      else if (statement.promotion) return statement.promotion
      else if (statement.invite) return statement.invite
      else if (statement.refund) return statement.refund
      else if (statement.luckydraw) return statement.luckydraw
      else if (statement.ranking) return statement.ranking

      return null
    },
    modalSlip() {
      this.modalSlipActive = !this.modalSlipActive
      this.disabledBodyScroll(this.modalSlipActive)
    },
    disabledBodyScroll(isModalShow) {
      if (isModalShow) document.documentElement.style.overflow = 'hidden'
      else document.documentElement.style.overflow = 'auto'
    }
  }
}
</script>

<style scoped lang="scss">
.log {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  background: white;
  color: black;
  border-radius: 15px;
  min-height: 120px;
  margin: 20px 0;

  .type {
    width: 45px;
    height: 45px;
    min-width: 45px;
    min-height: 45px;
    border-radius: 50%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: white;
    background: $primary;

    i {
      font-size: 18px;
    }
  }

  .detail {
    display: flex;
    align-items: center;
    // max-width: 300px;

    .activity {
      font-size: 14px;
      font-weight: 800;
      // white-space: nowrap;
      overflow: hidden;
      // text-overflow: ellipsis;
      // max-width: 250px;
    }

    .status {
      font-size: 14px;
      // font-weight: 700;
    }

    .datetime,
    .timeago {
      font-size: 12px;
    }

    .timeago {
      color: $dark;
    }
  }

  .amount {
    font-size: 18px;
    font-weight: 800;
    white-space: nowrap;
  }

  &.deposit {
    .type {
      background: $success;
    }
    .amount {
      color: $success;
    }
  }

  &.bonus {
    .type {
      background: $info;
    }
    .amount {
      color: $info;
    }
  }

  &.transfer {
    .type {
      background: $warning;
    }
    .amount {
      color: $warning;
    }
  }
  &.withdraw,
  &.finish_bonus {
    .type {
      background: $danger;
    }
    .amount {
      color: $danger;
    }
  }
}

.inline-flex {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.block {
  margin-bottom: 20px;
}
</style>
